module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/fancy-box/fancy-box.component.scss
// module id = ./src/app/features/fancy-box/fancy-box.component.scss
// module chunks = main